import { TablerIcon } from '@rossum/ui/icons/tabler';
import { Box, SvgIcon } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

export type DialogIconColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'info'
  | 'success'
  | 'warning';

type DialogTitleIconProps = {
  Icon?: TablerIcon;
  iconBackgroundColor?: DialogIconColor;
};

const DialogTitleIcon = ({
  Icon,
  iconBackgroundColor,
}: DialogTitleIconProps) => {
  if (!Icon) return null;
  if (!iconBackgroundColor)
    return (
      <SvgIcon fontSize="medium">
        <Icon />
      </SvgIcon>
    );

  return (
    <Box
      sx={{
        minWidth: 32,
        minHeight: 32,
        my: 0.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: borderRadius('xl'),
        backgroundColor: theme => theme.palette[iconBackgroundColor].main,
      }}
    >
      <SvgIcon fontSize="medium">
        <Icon />
      </SvgIcon>
    </Box>
  );
};

export default DialogTitleIcon;
